import React, { useEffect, useState } from 'react'
import SchemeForm from '../../components/Forms/Scheme/SchemeForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { useScheme } from '../../hooks/CompanyConfiguration/useScheme'
import { calculateMonthRange, ROUTES } from '../../shared/constants'

export default function AddScheme({ scheme }) {
  const { addScheme, updateScheme } = useScheme()
  const [schemeForm, setSchemeForm] = useState({
    name: '',
    date: new Date(),
    schemeBasedOn: '',
    category: null,
    validity: '',
    schemeType: '',
    saleValue: '',
    incentive: '',
    schemeFrom: new Date(),
    schemeTo: new Date(),
    noOfMonths: '',
    schemeCode: '',
    schemeFor: '',
  })
  const [store, setStore] = useState([])
  const [product, setProduct] = useState([])

  //console.log('No Of Months', schemeForm.noOfMonths)

  const handleAddScheme = () => {
    if (scheme) {
      updateScheme({
        schemeId: scheme._id,
        name: schemeForm.name,
        date: schemeForm.date,
        products: product,
        store: store,
        category: schemeForm.schemeBasedOn === 'PRODUCT' ? null : schemeForm.category,
        validity: schemeForm.validity,
        schemeType: schemeForm.schemeType,
        saleValue: schemeForm.saleValue,
        incentive: schemeForm.incentive,
        schemeFrom: schemeForm.schemeFrom,
        schemeBasedOn: schemeForm.schemeBasedOn,
        schemeFor: schemeForm.schemeFor,
        schemeTo: schemeForm.validity === 'CUSTOM' ? schemeForm.schemeTo : calculateMonthRange(schemeForm.schemeFrom, schemeForm.noOfMonths, schemeForm.validity),
        noOfPeriods: schemeForm.noOfMonths,
        schemeCode: schemeForm.schemeCode,
      })
    } else {
      addScheme({
        schemeCode: schemeForm.schemeCode,
        name: schemeForm.name,
        date: schemeForm.date,
        products: product,
        category: schemeForm.category,
        store: store,
        validity: schemeForm.validity,
        schemeType: schemeForm.schemeType,
        saleValue: schemeForm.saleValue,
        incentive: schemeForm.incentive,
        schemeFrom: schemeForm.schemeFrom,
        schemeTo: schemeForm.validity === 'CUSTOM' ? schemeForm.schemeTo : calculateMonthRange(schemeForm.schemeFrom, schemeForm.noOfMonths, schemeForm.validity),
        noOfPeriods: schemeForm.noOfMonths,
        schemeBasedOn: schemeForm.schemeBasedOn,
        schemeFor: schemeForm.schemeFor,
      })
    }
  }

  useEffect(() => {
    if (scheme) {
      setSchemeForm({
        ...schemeForm,
        name: scheme.name,
        date: scheme.date,
        category: scheme.category && scheme.category.length > 0 && scheme.category[0]._id,
        schemeBasedOn: scheme.category ? 'CATEGORY' : 'PRODUCT',
        validity: scheme.validity,
        schemeType: scheme.schemeType,
        saleValue: scheme.saleValue,
        incentive: scheme.incentive,
        schemeFrom: scheme.schemeFrom,
        schemeTo: scheme.schemeTo,
        noOfMonths: scheme.noOfPeriods,
        schemeCode: scheme.schemeCode,
        schemeFor: scheme.schemeFor,
      })
      setProduct(scheme.products && scheme.products.map((item) => item._id))
      setStore(scheme.store && scheme.store.map((item) => item._id))
    }
  }, [scheme])

  return (
    <Layout heading="Scheme" heading2={scheme ? 'Edit' : 'Add'} url1={ROUTES.SCHEME} none>
      <HeaderTabLayout
        heading={`${scheme ? 'Edit' : 'Add'} Scheme`}
        content={<SchemeForm form={schemeForm} setForm={setSchemeForm} store={store} setStore={setStore} product={product} setProduct={setProduct} scheme={scheme} />}
        addContent={handleAddScheme}
        redirect={ROUTES.SCHEME}
      />
    </Layout>
  )
}
